import React, { useEffect, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg13 from "../../../assets/svg/svg13.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../features/obj/objSlice";
import { formatText } from "../../../utils";
import ConfirmModal from "../../../components/ConfirmModal";
import moment from "moment";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";

function PartnerTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/irrPart/fetch";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { activeObjCatPartners } = useSelector((state) => ({
    activeObjCatPartners: state.obj.activeObj["partners-category"],
  }));
  const { saving } = useSelector((state) => state.save);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        mipName: e.target.value == "" ? null : e.target.value, 
        mipIrrigationPartnerType: activeObjCatPartners?.type, 
        start: 0,
        limit: null,
      })
    );
  };
 

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/irrPart/delete",
        ipId: prodd?.ipId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await fetchPartnerData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "partners", data: prodd }));
    await navigate("/irrigation-partner-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "partners", data: {} }));
    await navigate("/irrigation-partner-add");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "partners", data: prodd }));
    await navigate("/partner-view");
  };  
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "partners", data: item }));
    await navigate("/partner-view");
  };  
  
  const settingItems = [
    {
      key: "1",
      label: (
        <div   onClick={handleEdit}>
          <Link
          
            className="flex items-center gap-x-2 actions-text my-2"
          >
            <img src={svg12} alt="svg12" className="w-4 h-4" />
            <span className="whitespace-nowrap">Edit</span>
          </Link>
          <div className="mt-4">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div  onClick={handleView}>
          <Link
           
            className="flex items-center gap-x-2 actions-text my-2"
          >
            <img src={svg15} alt="svg15" className="w-4 h-4" />
            <span className="whitespace-nowrap">View</span>
          </Link>
          <div className="mt-4">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div     onClick={handleOpenDelete}>
          <Link
        
            className="flex items-center gap-x-2 actions-text my-2"
          >
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Institution", 
      render:(item)=>{
        return(
          <div className="cursor-pointer" onClick={()=>handleViewName(item)}>{item?.mipName}</div>
        )
      },
      sorter: (a, b) => a.mipName.localeCompare(b.mipName),
    },

    {
      title: "Location",
      dataIndex: "mipPhysicalLocation",
      sorter: (a, b) =>
        a.mipPhysicalLocation.localeCompare(b.mipPhysicalLocation),
    },
    {
      title: "MD/CEO",
      dataIndex: "mipCeoOrMdName",
      sorter: (a, b) => a.mipCeoOrMdName.localeCompare(b.mipCeoOrMdName),
    },
    {
      title: "Admin Phone",
      dataIndex: "mipContactPhoneNumber",
      sorter: (a, b) =>
        a.mipContactPhoneNumber.localeCompare(b.mipContactPhoneNumber),
    },
    {
      title: "Registered",
      dataIndex: "createdDate",
      render: (text) =>
        text ? moment(text).format("DD-MM-YYYY") : "--",
      sorter: (a, b) =>
        moment(a.createdDate).valueOf() - moment(b.createdDate).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "mipStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PENDING_APPROVAL: "#3250FF",
          INACTIVE: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchPartnerData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        mipIrrigationPartnerType: activeObjCatPartners?.type,
        mipName: null,
      })
    );
  }

  useEffect(() => {
    fetchPartnerData();
  }, []);
 

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb
        breadcrumbs={[
          { title: "Irrigation Partners", path: "/irrigation-partner-list" },
          { title: `${formatText(activeObjCatPartners?.type)} View` },
        ]}
      />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="form-add-h">{formatText(activeObjCatPartners?.type)}</div>
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[1.75rem] gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
          <div className="w-[100px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <span className="ml-1">Add</span>
            </button>
          </div>
        </div>

        <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className="mt-[1.31rem] w-full"
              scroll={{
                x: 1200,
              }}
              rowKey={(record) => record?.ipId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchPartnerData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </section>
        </div>
      </div>
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default PartnerTable;
